import { useTranslation } from 'react-i18next';
import CircleProgress, {percentage} from '../../../../../component/circleProgress/CircleProgress';
import {DEFAULT_COLOR} from '../../../../../globalVariables/GlobalVariables';
import * as css from './conversionRates.css';

function ConversionRates({lead={transactions:0,ticliCount:0}}) {
    const {t} = useTranslation('publish');
    return (
        <css.conversionRates>
            <CircleProgress styleProps={{pathColor: DEFAULT_COLOR,strokeTrailWidth:0.0001}} partialValue={lead.transactions} totalValue={lead.ticliCount} >
                <css.circle>{percentage(lead.ticliCount, lead.transactions)}%
                    <css.percent>{t('המרה')}</css.percent>
                </css.circle>
            </CircleProgress>
        </css.conversionRates>
    );
}
export default ConversionRates;